/**
 * React hook to execute download links
 */

import { useEffect } from 'react';

const useDownload = (downloadUrl?: string) => {
  useEffect(() => {
    if (downloadUrl) {
      const link = document.createElement('a');
      link.href = downloadUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, [downloadUrl]);
};

export default useDownload;
